import {
  queryUserCompany,

  getInsuranceQueryInsuranceOrderList,
  getInsuranceReceiveRecords,
  postInsuranceAddBatch,
  getInsuranceGetSurplus,
  getInsuranceQueryInsuranceDetailsNew,
  postInsuranceSubmitReceiveOrder,
  getInsuranceQueryInsuranceReveived,

  getOrderQueryOrderDetail,
} from '@/api/insurance';

const actions = {
  // 获取保险员所在公司
  async acGetUserCompany({ commit, state }, params) {
    const res = await queryUserCompany(params);
    commit('muSetUserCompany', res.data);
    if (res.data && res.data.name) {
      commit('muCheckIstoBUser', true);
    }
    return res;
  },

  // 获取订单列表
  async acGetOrderList({ commit, state }, params) {
    const res = await getInsuranceQueryInsuranceOrderList(params);
    commit('muSetOrderList', res.data);
    return res;
  },

  // 获取订单详情
  async acGetOrderQueryOrderDetail({ commit, state }, params) {
    const res = await getOrderQueryOrderDetail(params);
    commit('muSetOrderDetail', res.data);
    return res;
  },

  // 获取订单详情中的领取记录
  async acGetOrderDetailReceiveList({ commit, state }, params) {
    const res = await getInsuranceReceiveRecords(params);
    commit('muSetOrderDetailReceiveList', res.data);
    return res;
  },
  // 添加领取批次
  async acAddReceiveBatch({ commit, state }, params) {
    const res = await postInsuranceAddBatch(params);
    return res;
  },
  // 获取可赠份数
  async acGetCanBeGiveNumber({ commit, state }, params) {
    const res = await getInsuranceGetSurplus(params);
    return res;
  },
  // 获取批次订单详情
  async acOrderDetail({ commit, state }, params) {
    const res = await getInsuranceQueryInsuranceDetailsNew(params);
    commit('muSetShareOrderDetail', res.data);
    return res;
  },
  // 领取
  async acReceiveOrder({ commit, state }, params) {
    const res = await postInsuranceSubmitReceiveOrder(params);
    return res;
  },
  // 获取领取页中的领取记录
  async acGetReveivePageReceiveList({ commit, state }, params) {
    const res = await getInsuranceQueryInsuranceReveived(params);
    commit('muSetShareReceivedList', res.data);
    return res;
  },
};
export default actions;
